export const shouldShowHeaderShareButtons = state => state.shareButtons.showHeaderShareButtons



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/shareButtons/shareButtons.selectors.js